import { Button } from 'antd';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { getExportDashboard, getExportDashboardTask } from '../../../services/task';
import moment from 'moment';
import { useTranslation } from "react-i18next";


const ExportExcel = () => {
  const { t } = useTranslation();
  const exportExcel = async () => {
    const res = await getExportDashboard()
    const task = await getExportDashboardTask()
    const task_result = task.data.map((item)=>{
      return {
        name:item.name,
        task_type:item.type == 1 ? "event":"general",
        sub_type:item.submission_type == 1 ? "model":"result",
        date: (item.start_date != null ? moment(item.start_date).format('DD/MM/YYYY'): "ไม่มีกำหนด") + "-" +(item.end_date != null ? moment(item.end_date).format('DD/MM/YYYY'): "ไม่มีกำหนด"),
        member:item.member? item.member:0,
        member_submit: item.member_submission ? item.member_submission.length:0,
        all_submission: item.all_submission[0]?item.all_submission[0].count:0 ,
        avg_submission: item.avg_submission ? item.avg_submission:0,
        test1:0,
        test2:0,
        test3:0,
        resource:item.resource
      }
    }).map((item)=>Object.values(item))
    const workbook = new ExcelJS.Workbook();
    // =============sheet detail================
    const detailsheet = workbook.addWorksheet('Summary');

    detailsheet.getCell('A1').value='รายการ'
    detailsheet.getCell('B1').value='สถิติ'
    detailsheet.getCell('A2').value='จำนวนผู้ใช้งานทั้งหมด'
    detailsheet.getCell('A3').value='จำนวนผู้ใช้งานที่ลงทะเบียนกิจกรรม'
    detailsheet.getCell('A4').value='จำนวนผู้ใช้งานที่ส่งโมเดลเข้าร่วมทดสอบ'
    detailsheet.getCell('A5').value='จำนวนกิจกรรม (Task) [General]'
    detailsheet.getCell('A6').value='จำนวนกิจกรรม (Task) [Event]'
    detailsheet.getCell('A7').value='กิจกรรม (Task) ที่ได้รับความนิยม'
    detailsheet.getCell('A8').value='จำนวน Submit ทั้งหมด'
    detailsheet.getCell('A9').value='จำนวน Sumit สูงสุด ต่อ Task'
    detailsheet.getCell('A10').value='จำนวนดาวน์โหลด Dataset'
    detailsheet.getCell('A11').value='Dataset ที่ได้รับความนิยม'

    // ตั้งค่า background color และจัดตำแหน่งข้อความสำหรับเซลล์หัวคอลัมน์
    const detailHeader = ['A1', 'B1'];
    detailHeader.forEach(cell => {
      detailsheet.getCell(cell).alignment = { horizontal: 'center', vertical: 'middle' };
        detailsheet.getCell(cell).font = { bold: true };
        detailsheet.getCell(cell).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'DAE9F8' }, // สีเหลืองทอง
        };
    });

  const widthColumnsDetail = [
      { width: 20 },
      { width: 100 }, 
  ]
  detailsheet.columns = widthColumnsDetail

  // value=======================
  // ====sec1=======
  detailsheet.getCell('B2').value= res.data?.all_user
  detailsheet.getCell('B3').value= res.data?.all_member
  detailsheet.getCell('B4').value= res.data?.user_submission
  detailsheet.getCell('B5').value= res.data?.general_task
  detailsheet.getCell('B6').value= res.data?.event_task
  detailsheet.getCell('B7').value= res.data?.hot_task.name
  detailsheet.getCell('B8').value= res.data?.all_submission
  detailsheet.getCell('B9').value= res.data?.task_submission
  detailsheet.getCell('B10').value= res.data?.dataset_dowload
  detailsheet.getCell('B11').value= res.data?.hot_dataset


    // =============sheet performance================
    const worksheet = workbook.addWorksheet('Task');

    // Merge Column ด้านบน
    worksheet.mergeCells('A1:A2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('B1:B2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('C1:C2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('D1:D2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('E1:E2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('F1:F2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('G1:G2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('H1:H2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('I1:I2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('J1:J2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('K1:K2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('L1:L2'); // รวมเซลล์ F1 และ G1
    worksheet.mergeCells('M1:Q1'); // รวมเซลล์ F1 และ G1

    // =========
    worksheet.getCell('A1').value='กิจกรรม'
    worksheet.getCell('B1').value='Task Type'
    worksheet.getCell('C1').value='Submission Type'
    worksheet.getCell('D1').value='ระยะเวลา (เริ่มต้น-สิ้นสุด)'
    worksheet.getCell('E1').value='จำนวนผู้ลงทะเบียน'
    worksheet.getCell('F1').value='จำนวนผู้ submit'
    worksheet.getCell('G1').value='จำนวน submit'
    worksheet.getCell('H1').value='จำนวน submit เฉลี่ยต่อคน'
    worksheet.getCell('I1').value='Accuracy (Baseline)'
    worksheet.getCell('J1').value='เวลา inference ต่ำสุด'
    worksheet.getCell('K1').value='เวลา inference เฉลี่ย'
    worksheet.getCell('L1').value='Resource'
    worksheet.getCell('M1').value='สถิติของผู้ชนะอันดับ 1'
    worksheet.getCell('M2').value='ชื่อโมเดล'
    worksheet.getCell('N2').value='Accuracy'
    worksheet.getCell('O2').value='ขนาดโมเดล'
    worksheet.getCell('P2').value='เวลา inference'
    worksheet.getCell('Q2').value='ชื่อผู้ใช้'


    worksheet.getCell('M1').alignment = { horizontal: 'center', vertical: 'middle' }; // จัดตำแหน่งข้อความ
    worksheet.getCell('M1').font = { bold: true }; // ทำให้ตัวอักษรหนาฃ
    worksheet.getCell('M1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'A6C9EC' }, 
      };

      
    // ตั้งค่า background color และจัดตำแหน่งข้อความสำหรับเซลล์หัวคอลัมน์
    const headerCells = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1','G1','H1','I1','J1','K1','L1','M2','N2','O2','P2','Q2'];
    headerCells.forEach(cell => {
        worksheet.getCell(cell).alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getCell(cell).font = { bold: true };
        worksheet.getCell(cell).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'DAE9F8' },
        };
    });

    const widthColumns = [
        { width: 10 }, // อันดับ
        { width: 15 }, // ชื่อผู้ใช้
        { width: 15 }, // จำนวน submit
        { width: 20 }, // ชื่อโมเดล
        { width: 15 }, // ขนาดโมเดล
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
        { width: 20 }, // เวลา inference
    ]

    // เพิ่มข้อมูลแต่ละแถว
    const data = [
      [1, 'User A', 10, 'Model X', '50MB', '0.2s', 0.95, 0.88],
      [2, 'User B', 7, 'Model Y', '75MB', '0.5s', 0.89, 0.84],
      [3, 'User C', 12, 'Model Z', '30MB', '0.1s', 0.97, 0.91],
    ];

    // data.forEach(row => {
      task_result.forEach(row => {
      worksheet.addRow(row);
    });

    // จัดฟอร์แมต: ทำให้หัวตาราง (แถวที่ 2) เป็นตัวหนา
    worksheet.getRow(2).font = { bold: true };

    // กำหนดความกว้างของคอลัมน์
    worksheet.columns = widthColumns
    
    // บันทึกไฟล์ Excel
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `dashboard_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  return (
    <div>
      <Button  style={{ backgroundColor: "#00215E", color: "white" }}  type="primary" onClick={exportExcel}>{t("Export")}</Button>
    </div>
  );
};

export default ExportExcel;